module.exports = __webpack_public_path__ + "static/media/hubspot.c35193e2.svg";